// extracted by mini-css-extract-plugin
export var ask_chat_wrapper = "askChat-module--ask_chat_wrapper--9290e";